import { getAttributeValue } from '../../../../helpers/getAttributeValue';

const getCategory = getAttributeValue('category');

export default {
  check: (sourceItem, targetItem) => getCategory(sourceItem) === getCategory(targetItem),
  errorMessage: (/* sourceItem, targetItem */) => (
    'Incorrect measurement category'
  ),
};
